
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?-autoprefixer&sourceMap!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-31e85f9a\",\"scoped\":false,\"hasInlineConfig\":false}!postcss-loader?sourceMap!sass-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./drag-surface.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!buble-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./drag-surface.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-31e85f9a\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./drag-surface.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/drag-surface.vue
// module id = 305
// module chunks = 1